import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";

const getUpdateColumns = (onEdit, onDelete) => {
  return [
    {
      Header: "Code",
      accessor: "code",
      width: 12,
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      disabled: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Description",
      accessor: "description",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 12,
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "File Name",
      accessor: "wavFile",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 12,
      controlType: "select",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "name",
        keyDescription: "name",
        values: [],
        url: "announcement/list",
      },
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getUpdateColumns};
